import React from "react";
import resetPassword from "assets/Login/resetPassword.png";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import { useForm } from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import { Link, useNavigate } from "react-router-dom";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import authService from "services/authService";
import Toast from "components/molecules/Toast";
import { useSearchParams } from "react-router-dom";
const ChangePassword = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    if (!token) {
        Toast({ type: "error", message: "Invalid or expired setup token" });
        return;
    }
    setLoading(true);
    try {
        await authService.resetPassword({ password: e.new_password }, token);
        Toast({ type: "success", message: "Password set successfully! You can now log in." });
        navigate("/login");
    } catch (error) {
        Toast({ type: "error", message: error.message });
    } finally {
        setLoading(false);
    }
  };
  return (
    <>
      <OnBoardingLayout  img={resetPassword}>
          <Heading
            heading="Change Password"
            para="Please enter a new password!"
          />
          <Form form={form} onSubmit={handleSubmit}>
            <Form.Item
              label="Enter New Password"
              type="password"
              rounded
              name="new_password"
              lg
              placeholder="Enter New Password"
              $bgWhite
              rules={[
                {
                  required: true,
                  message: "Password is required",
                },
              ]}
            >
              <Field />
            </Form.Item>
            <Form.Item
              label="Confirm Password"
              type="password"
              rounded
              name="confirm_password"
              lg
              placeholder="Confirm New Password"
              $bgWhite
              rules={[
                {
                  required: true,
                  message: "Confirm password is required",
                },
                {
                  transform: (value) => form.getFieldValue("new_password") !== value,
                  message: "Passwords do not match",
                }
              ]}
            >
              <Field />
            </Form.Item>
            <div className="btn-holder">
              <Button lg type="submit" loader={loading}>Save Password</Button>
              {/* <div className="textWrapper">
                <span>Already have an account? &nbsp;</span>
                <Link to="/" className="linkSignup">
                  Sign In
                </Link>
              </div> */}
            </div>
          </Form>
      </OnBoardingLayout>
    </>
  );
};

export default ChangePassword;
